module.exports = __webpack_public_path__ + "static/media/ramazan-mobile-banner-2025.474109d2.jpg";